import { List, Record, type RecordOf } from 'immutable';

import { isRecordOf } from './recordHelpers';

export type ColumnProps = {
  id?: number;
  field?: string;
  headerName?: string;
};
export type Column = RecordOf<ColumnProps>;
export const mkColumn = Record<ColumnProps>({
  id: undefined,
  field: undefined,
  headerName: undefined,
});

export type CellProps = {
  id?: number;
  columnId?: number;
  value?: number;
};
export type Cell = RecordOf<CellProps>;
export const mkCell = Record<CellProps>({
  id: undefined,
  columnId: undefined,
  value: undefined,
});

export type RowProps = {
  id?: number;
  name?: string;
  entityId?: number;
  cellData?: List<Cell>;
};
export type RowRecord = RecordOf<RowProps>;
const Row = Record<RowProps>({
  id: undefined,
  name: undefined,
  entityId: undefined,
  cellData: undefined,
});
/** A row as the server sends it. */
type RowData = Omit<RowProps, 'cellData'> & { cellData?: Iterable<CellProps | Cell> };
export const mkRow = (obj?: RowData | RowRecord | null) =>
  Row({
    ...(isRecordOf(obj) ? obj.toJS() : obj),
    cellData: List(obj?.cellData).map((cell) => mkCell(cell)),
  });

export type ReportStoreProps = {
  startOn?: string;
  endOn?: string;
  timestep?: string;
  rowType?: string;
  columnType?: string;
  columns?: List<Column>;
  rows?: List<RowRecord>;
  loadPending?: boolean;
  isLoading?: boolean;
  error?: string;
};
const ReportStore = Record<ReportStoreProps>({
  startOn: undefined,
  endOn: undefined,
  timestep: undefined,
  rowType: undefined,
  columnType: undefined,
  columns: undefined,
  rows: undefined,

  loadPending: true,
  isLoading: false,
  error: undefined,
});

/** A report as the server sends it. */
type ReportData = Omit<ReportStoreProps, 'columns' | 'rows'> & {
  columns?: Iterable<ColumnProps | Column>;
  rows?: Iterable<RowData | RowRecord>;
};
export const mkReportStore = (obj?: ReportData | RecordOf<ReportStoreProps> | null) =>
  ReportStore({
    ...(isRecordOf(obj) ? obj.toJS() : obj),
    columns: List(obj?.columns).map((column) => mkColumn(column)),
    rows: List(obj?.rows).map((row) => mkRow(row)),
  });
